import React, { createContext, useContext, useState } from "react";

const ChainContext = createContext();

export const ChainProvider = ({ children }) => {
  const [reFethData, setReFetchData] = useState(false);
  const [socket, setSocket] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <ChainContext.Provider
      value={{
        reFethData,
        setReFetchData,
        socket,
        setSocket,
        currentPage, setCurrentPage
      }}
    >
      {children}
    </ChainContext.Provider>
  );
};

export const useChainContext = () => {
  const context = useContext(ChainContext);
  if (!context) {
    throw new Error("useChainContext must be used within a ChainProvider");
  }
  return context;
};
